import { create } from 'zustand';
import { JSX } from 'react';

interface HomeStore {
  showBottomSheet: boolean;
  Body: () => JSX.Element;
  bgLighter?: boolean;
  onDemandClose?: boolean;
  setShowBottomSheet: (
    showBottomSheet: boolean,
    options?: {
      Body?: () => JSX.Element;
      bgLighter?: boolean;
      onDemandClose?: boolean;
    },
  ) => void;
}

const useBottomSheetStore = create<HomeStore>((set, get) => ({
  showBottomSheet: false,
  Body: () => <></>,
  bgLighter: false,
  onDemandClose: true,
  setShowBottomSheet: (
    showBottomSheet,
    { bgLighter = false, onDemandClose = true, Body = () => <></> } = {
      Body: get().Body,
      bgLighter: false,
    },
  ) =>
    set({
      showBottomSheet,
      onDemandClose,
      bgLighter,
      Body,
    }),
}));
export default useBottomSheetStore;